import { render } from "./DeleteOppModal.vue?vue&type=template&id=36c8a1d0"
import script from "./DeleteOppModal.vue?vue&type=script&lang=js"
export * from "./DeleteOppModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__